import { createReducer, on } from '@ngrx/store';
import { TaskState } from '../../models/task-state';
import * as tasksActions from './tasks.actions';

export const tasksKey = 'tasks';

export const taskInitialState: TaskState = {
    tasks: [],
    editTask: null,
    isLoaded: false,
    isLoading: false,
    loadMessages: false,
    description: ''
};

export const tasksReducer = createReducer(
    taskInitialState,
    on(tasksActions.taskList, (state) => ({
        ...state,
        isLoading: true,
        isLoaded: false,
        loadMessages: false
    })),
    on(tasksActions.tasksListSuccess, (state, response) => ({
        ...state,
        tasks: response.tasks,
        isLoading: false,
        loadMessages: false,
        isLoaded: true
    })),
    on(tasksActions.setTask, (state, response) => ({
        ...state,
        editTask: response.editTask,
        isLoading: false,
        loadMessages: false,
        isLoaded: true
    })),
    on(tasksActions.setTaskSuccess, (state, response) => ({
        ...state
    })),
);
